module.exports = __webpack_public_path__ + "img/FR15848.d5129e37.svg";